import { render, staticRenderFns } from "./registerc.vue?vue&type=template&id=61ef87e1&scoped=true"
import script from "./registerc.vue?vue&type=script&lang=js"
export * from "./registerc.vue?vue&type=script&lang=js"
import style0 from "./registerc.vue?vue&type=style&index=0&id=61ef87e1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61ef87e1",
  null
  
)

export default component.exports